import { CreateFileEntryPayload, FILE_UPLOAD_TYPE } from "model";

export type FileEntryFormData = {
  fileDescription?: string;
  fileUploadType?: FILE_UPLOAD_TYPE;
  file?: string;
  fileName?: string;
  fileUploadId?: string;
  associatedUserId?: string;
};
export const convertFromFormInput = (
  fileUploadFormData: FileEntryFormData,
  userId: string
): CreateFileEntryPayload => {
  return {
    fileDescription: fileUploadFormData.fileDescription ?? "",
    fileUploadType:
      fileUploadFormData.fileUploadType ?? FILE_UPLOAD_TYPE.CARBON_AUDIT_REPORT,
    fileUploadId: fileUploadFormData.fileUploadId ?? "",
    associatedUserId: fileUploadFormData.associatedUserId ?? "",
    userId: userId,
  };
};
